/**
 * QUIPWA — the app's auth session (singleton) and its wiring to Drive.
 *
 * Import `authSession` from here, never construct AuthSession elsewhere.
 * Tests construct their own AuthSession with fake dependencies.
 */
import { AuthSession } from './auth-session.ts'
import { connectDriveAuth } from '../drive/drive-service.ts'

export const authSession = new AuthSession({
  clientId: import.meta.env['VITE_GOOGLE_CLIENT_ID'] as string | undefined,
  redirectUri: () => `${window.location.origin}/auth/callback`,
  navigate: (url) => window.location.assign(url),
  now: () => Date.now(),
  fetch: (input, init) => globalThis.fetch(input, init),
  storage: localStorage,
  sessionStorage,
})

connectDriveAuth({
  getAccessToken: () => authSession.getAccessToken(),
  onUnauthorized: () => authSession.markUnauthorized(),
  onInsufficientScope: () => authSession.markInsufficientScope(),
})

export type { AuthState, AuthStatus, GoogleUser, CallbackOutcome } from './auth-session.ts'
export { SCOPES } from './oauth.ts'
